import { BoxExploreB2BProgramsLayout } from "@modules/boxB2BProgram/components/boxExploreB2BProgramsLayout"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { ErrorBoundary } from "react-error-boundary"
import { Suspense } from "react"
import type { SidebarNavigatorParams } from "@/modules/sidebar/sidebarTypes"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { ErrorView } from "@/components/ui/layout/error/errorView"

export const useBoxExploreSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToBoxExploreB2BPrograms = (args: SidebarNavigatorParams) => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxExploreB2BProgramsLayout />
          </Suspense>
        </ErrorBoundary>
      ),
      ...args,
    })
  }

  return { navigateToBoxExploreB2BPrograms }
}
